import REDUX_SORT_KEY from 'modules/redux/constants/sort-key'

function getSortKeyReduxUtil (domainPath, domainListPath) {
  const sortKeyObj = REDUX_SORT_KEY[domainPath]
  return sortKeyObj ? sortKeyObj[domainListPath] : null
}

export default getSortKeyReduxUtil
